export const base = {
  btn: {
    saveAndUpdate: 'SAVE AND UPDATE',
    update: 'UPDATE',
  },
  general: {
    active: 'Active',
    actual: 'Actual',
    auto: 'Auto',
    automatic: 'Automatic',
    autoAssign: 'Auto-Assign',
    add: 'ADD',
    all: 'All',
    any: 'Any',
    apply: 'APPLY',
    cancel: 'CANCEL',
    cannotUndo: 'This cannot be undone.',
    clear: 'CLEAR',
    close: 'CLOSE',
    confirm: 'APPLY CHANGES',
    create: 'CREATE',
    default: 'DEFAULT',
    delete: 'Delete',
    deleteBtn: 'DELETE',
    deleteSelected: 'DELETE SELECTED',
    disabled: 'Disabled',
    done: 'DONE',
    download: 'Download',
    duplicate: 'Duplicate',
    edit: 'Edit',
    enable: 'ENABLE',
    enabled: 'Enabled',
    format: 'Format',
    generate: 'GENERATE',
    home: 'HOME',
    id: 'ID',
    import: 'IMPORT',
    install: 'INSTALL',
    later: 'LATER',
    load: 'Load',
    lock: 'LOCK',
    maxSimultaneousFileUploads: 'Only {{max}} files can be uploaded simultaenously',
    mute: 'Mute',
    name: 'Name',
    no: 'No',
    noMatches: 'No Matches',
    none: 'None',
    noneSelected: '(None)',
    off: 'Off',
    ok: 'OK',
    on: 'On',
    password: 'Password',
    proceed: 'Proceed',
    reboot: 'REBOOT',
    rebootLater: 'REBOOT LATER',
    redirecting: 'Redirecting...',
    rename: 'Rename',
    reset: 'RESET',
    retry: 'RETRY',
    save: 'Save',
    saveBtn: 'SAVE',
    saveReboot: 'SAVE & REBOOT',
    search: 'Search',
    select: 'SELECT',
    settings: 'Settings',
    signOut: 'Sign Out',
    start: 'START',
    state: 'State',
    statistics: 'Statistics',
    status: 'Status',
    stop: 'STOP',
    subject: 'Subject',
    test: 'TEST',
    type: 'Type',
    unknown: 'Unknown',
    unlock: 'UNLOCK',
    unlicensed: 'Unlicensed',
    unmute: 'Unmute',
    upload: 'UPLOAD',
    uploading: 'Uploading',
    yes: 'Yes',
    version: 'version',
    view: 'View',
  },
  presets: {
    active: 'ACTIVE',
    addFirst: 'No Presets to Display',
    autoSave: 'Autosave',
    configNotSaved: 'Unsaved changes',
    dropdownHeader: 'Device Presets',
    invalidFileName: 'File name is invalid',
    modifiedTime: 'Modified',
    noPreset: 'No Active Preset',
    presetLoad: 'Load Preset',
    loadPresetConfirmTitle: 'Load Preset?',
    loadPresetConfirmBody: 'By reloading the current configuration, you will lose any unsaved changes.',
    presetManager: 'Preset Manager',
    presetSaved: 'Saved',
    presetNotSaved: 'Unsaved changes',
    replace: 'Replace',
    startup: 'STARTUP',

    notifications: {
      successSavingPreset: 'Preset saved',
      autoSaveErrorMsg: 'Autosave could not be set',
      autoSaveOnSuccessMsg: 'Autosave activated',
      autoSaveOffSuccessMsg: 'Autosave deactivated',
      createErrorMsg: "Preset '{{name}}' could not be created",
      createSuccessMsg: "Preset '{{name}}' created",
      overwriteErrorMsg: "Preset '{{name}}' could not be overwritten",
      overwriteSuccessMsg: "Preset '{{name}}' overwritten",
      saveWithoutActiveSuccessMsg: "Preset '{{name}}' updated with current settings",
      saveWithoutActiveErrorMsg: "Preset '{{name}}' could not be saved",
      duplicateErrorMsg: "Preset '{{name}}' could not be duplicated",
      duplicateSuccessMsg: "Preset '{{name}}' duplicated",
      deleteErrorMsg: "Preset '{{name}}' could not be deleted",
      importConfigurationErrorMsg: 'Invalid configuration file',
      importErrorMsg: "Preset '{{name}}' could not be imported",
      importSuccessMsg: "Preset '{{name}}' imported.",
      importAndLoadErrorMsg: "Preset '{{name}}' could not be imported and activated",
      importAndLoadSuccessMsg: "Preset '{{name}}' imported and activated",
      loadErrorMsg: "Preset '{{name}}' could not be loaded",
      loadSuccessMsg: "Preset '{{name}}' loaded",
      renameSuccessMsg: "Preset '{{name}}' renamed",
      renameErrorMsg: "Preset '{{name}}' could not be renamed",
      startupSetErrorMsg: "'{{name}}' could not be set as the startup preset",
      startupSetSuccessMsg: "'{{name}}' set as the startup preset",
      startupUnsetErrorMsg: "'{{name}}' could not be unset as the startup preset",
      startupUnsetSuccessMsg: "'{{name}}' unset as the startup preset",
      updateErrorMsg: "Preset '{{name}}' could not be saved",
      updateSuccessMsg: "Preset '{{name}}' saved",
    },
    menu: {
      load: 'Load...',
      managePresets: 'Manage Presets...',
      saveAs: 'Save As...',
    },
    modal: {
      form: {
        newTitle: 'New Preset',
        renameTitle: 'Rename Preset',
        saveAsTitle: 'Save Preset As',
        setAsStartup: 'Set as Startup',
      },
      delete: {
        title: 'Delete this preset?',
        title_plural: 'Delete {{count}} presets?',
      },
      overwrite: {
        title: 'Confirmation',
        bodyText: "'{{name}}' already exists. Do you want to replace it?",
      },
    },
  },
  streaming: {
    tabs: {
      audenc: 'Audio Encoders',
      input: 'Inputs',
      logos: 'Logos',
      metadata: 'Metadata',
      scte: 'Ad Insertions',
      stream: 'Streams',
      videnc: 'Video Encoders',
    },

    logos: {
      inputInterface: {
        DISPLAYPORT: 'DisplayPort',
        HDMI: 'HDMI',
        SDI: 'SDI',
      },
    },
  },
  sort: {
    ascending: 'Ascending',
    descending: 'Descending',
    sortPrefix: 'Sort',
    sortBy: 'SORT BY',
    sortOrder: 'SORT ORDER',
    sortText: {
      address: 'Address',
      bitrate: 'Bitrate',
      channel: 'Channel Mode',
      codec: 'Codec',
      content: 'Content',
      destination: 'Destination',
      encapsulation: 'Protocol',
      format: 'Format',
      id: 'ID',
      input: 'Input',
      language: 'Language',
      name: 'Name',
      resolution: 'Resolution',
      status: 'Status',
      type: 'Type',
    },
  },
  loading: {
    title: 'Loading, please wait…',
  },
  logoutNotSavedModal: {
    title: 'Unsaved Changes',
    body: 'The current running configuration was not saved.',
    button: {
      signout: 'SIGN OUT',
      saveSignout: 'SAVE & SIGN OUT',
    },
  },
  error: {
    failedToResolve: 'Failed to resolve host name',
    'Failed to validate stream address': 'Failed to validate stream address',
    'Unable to resolve destination address': 'Unable to resolve destination address',
    loginErrorIncorrect: 'Username or password is incorrect',
    loginErrorTooMany: 'Too many concurrent sessions',
    loginErrorUnknown: 'Unknown error. Please try again',
    requestInvalid: 'The request has been rejected by the server',
    serverError: 'An error occurred on the server',
    serverTimeout: 'Unable to reach the server in a timely manner',
    serverUnreachable: 'Unable to reach the server',
    systemNotLicensed: 'System requires license update',
    unknownError: 'An unknown error occurred',
  },
  notifications: {
    internalServerError: 'An unknown error occurred on the server',
    lostConnection: 'Communication with the device was lost',
    communicationRestored: 'Communication restored',
    prefixes: {
      Error: 'Error',
      Success: 'Success',
      SUCCESS_WITH_PREFIX: 'Success',
      Warning: 'Warning',
      Reminder: 'Reminder',
    },
    messages: {
      error: 'an unhandled error has occurred',
      success: 'the operation was successful',
      warning: 'an unhandled warning has occurred',
      reminder: 'a reminder was set',
    },
    encoder: {
      apply: 'applying encoder {{id}}',
      start: 'starting encoder {{id}}',
      stop: 'stopping encoder {{id}}',
    },
  },
  date: {
    longComponents: {
      years: 'Year',
      years_plural: 'Years',
      months: 'Month',
      months_plural: 'Months',
      days: 'Day',
      days_plural: 'Days',
      hours: 'Hour',
      hours_plural: 'Hours',
      minutes: 'Minute',
      minutes_plural: 'Minutes',
      seconds: 'Second',
      seconds_plural: 'Seconds',
    },
    shortComponents: {
      years: 'y',
      months: 'M',
      days: 'd',
      hours: 'h',
      minutes: 'm',
      seconds: 's',
    },
    picker: {
      amLabel: 'AM',
      applyLabel: 'APPLY',
      backLabel: 'BACK',
      cancelLabel: 'CANCEL',
      confirmLabel: 'CONFIRM',
      hhPlaceholder: 'hh',
      hoursLabel: '24 hours',
      mmPlaceholder: 'mm',
      monthLabel: 'Month',
      pmLabel: 'PM',
      yearLabel: 'Year',
    },
  },
  iconStatusType: {
    inactive: 'Inactive',
    streaming: 'Active',
    listening: 'Listening',
    error: 'Error',
    warning: 'Warning',
    stopped: 'Inactive',
    ready: 'Listening',
    'to-storage': 'Streaming',
  },
  notFound: {
    title: 'Oops!',
    containerTitle: '404 Page Not Found',
    containerSubtitle:
      'The page you are looking for might have been removed, may be temporarily unavailable or was possibly eaten by a shark.',
  },
  reboot: {
    title: 'Rebooting',
    confirm: {
      title: 'Reboot the Encoder?',
      body: 'This action will terminate all processes currently running and may take several minutes to restart.',
    },
    notSaved: {
      body: 'The current running configuration was not saved and will be lost if you reboot.',
    },
    header: 'The system is rebooting',
    subheader: 'Please refresh this page in 2 minutes if it does not refresh automatically.',
    upgrade: {
      header: 'Please do not reboot again or shut down the system during the update process.',
      subheader: 'The page will refresh automatically in about 15 minutes when the update is complete.',
    },
    savedModal: {
      title: 'Reboot Needed',
      body: 'The system must be restarted for changes to take effect. Do you want to reboot now?',
    },
    notSavedModal: {
      title: 'Save Configuration?',
      body1: 'The current configuration is not saved and will be lost if you reboot.',
      body2: 'Choose "Save and Reboot" to save the configuration and reboot.',
    },
    upgradeNotSavedModal: {
      body1: 'The current configuration is not saved and will be lost if you update.',
      body2: 'Choose "Save and Update" to save the configuration and update.',
    },
  },
  sidebar: {
    dashboard: 'Dashboard',
    help: 'Help Center',
    security: 'Security',
    settings: 'Settings',
    streams: 'Streaming',
  },
  login: {
    password_required: 'Password required',
    rememberMe: 'Remember Me',
    signin: 'SIGN IN',
    username_required: 'Username required',
    capsLockOn: 'Caps Lock is on',
  },
  passwordExpired: {
    title: 'Change Password',
  },
  dashboard: {
    title: 'Dashboard',
    addStreamButtonTitle: 'ADD STREAM',
  },
  help: {
    title: 'Help Center',
  },
  statistics: {
    options: {
      refreshInterval: 'Refresh Every',
    },
  },
  upload: {
    activateImportedPreset: 'Load imported preset',
    activateImportedPresetStartup: 'Load imported preset and set as startup',
    browseMessage: 'Browse',
    import: 'IMPORT',
    incorrectFileType: 'Incorrect file type!',
    mainMessage: 'Drag and drop to add a file',
    mainMessageAfterSelection: 'Drag and drop to replace the file',
    saveAndImport: 'SAVE AND IMPORT',
    saveAndLoad: 'SAVE AND LOAD',
    uploadSuccessMessage: 'Upload Successful',    
    uploadErrorMessage: 'Upload was not successful. ',
    tryAgain: 'Try Again',
    or: 'or',
    presetUploadNotSavedModal: {
      body1: 'The current configuration is not saved and will be lost if you import.',
      body2: 'Choose "Save and Import" to save the configuration and continue.',
    },
    presetLoadNotSavedModal: {
      body1: 'The current configuration is not saved and will be lost if you load.',
      body2: 'Choose "Save and Load" to save the configuration and continue.',
    },
    chooseFile: 'Choose a file',
    dragFile: 'or drag one here.',
    fileSelected: 'File Selected:',
  },
  userAnalytics: {
    inSettingsTitle: 'Product Analytics',
    inSettingsHeadingText: 'Enable Anonymous Product Analytics',
    inSettingsInfoText:
      'To help us build better products, we collect anonymous data from this product for analytics purposes. For more information, please review our',
    modalMainText:
      'Haivision is working to bring you the best products available. To help us better understand customer needs, we collect anonymous data from this product for analytics purposes. You can disable this by choosing Decline below, or at any time from the product’s settings.',
    modalMoreInformationText: 'For more information, please review our',
    modalContinueText: 'ACCEPT',
    modalDeclineText: 'DECLINE',
    modalTitle: 'Help Us Improve!',
    privacyPolicyText: 'privacy policy',
  },
  helpCenter: {
    header: 'Help Center',
    title: 'Get the Support You Need',
    description:
      'The Help Center is your go-to resource to quickly find solutions, learn about new updates, and get the most out of your product. We are here to support your journey every step of the way!',
    whatsNew: "What's New",
    documentationCenter: 'Documentation',
    openSupportTicket: 'Open a Support Ticket',
    supportPortal: 'Support Portal',
    releaseNotes: 'Release Notes',
    contactUs: 'Contact Us',
    northAmericaSupport: 'North America (Toll-Free)',
    franceSupport: 'France',
    ukSupport: 'United Kingdom',
    allOthersSupport: 'All Others',
    northAmericaSupportPhone: '1 (877) 224-5445',
    franceSupportPhone: '+33 2 56 56 50 18',
    ukSupportPhone: '+44 20 3936 8923',
    allOthersSupportPhone: '+1 (514) 334-5445',
    offlineWarningStart: 'Unable to connect to ',
    offlineWarningEnding: '. To access all Help features, please be sure the device has access to the internet.',
  },
};
